import React, { useEffect , useState} from 'react'
import { BrowserRouter as Router, Route, Outlet} from "react-router-dom";
import GConf from '../generalConf';
import { getToken } from "firebase/messaging";
import { messaging } from "../firebase";
import axios from 'axios';
import { Button, Loader } from 'semantic-ui-react';


//navBar
import NavBar from '../../Dashboard/navBar'
import LeftSideCard from '../../Dashboard/leftSide';

//Main
import MainPage from '../../Dashboard/Main/mainPage';

//Commandes
import RequestPage from '../../Dashboard/Requests/requestPage';
import RequestCommandeInfo from "../../Dashboard/Requests/requestInfo";
import CalendarCommandes from '../../Dashboard/Requests/calendar';


//Voiture
import VoiturePage from '../../Dashboard/Voitures/voiturePage';
import AjouterVoiture from '../../Dashboard/Voitures/ajouterVoiture';
import VoitureInfo from "../../Dashboard/Voitures/voitureInfo";
import EditVoiture from '../../Dashboard/Voitures/editVoiture';

//Stock
import OffrePage from '../../Dashboard/Offres/forfaitPage';
import OffreInfo from "../../Dashboard/Offres/forfaitInfo";


//Facture
import ReservationsPage from "../../Dashboard/Reservations/reservationsPage";
import AjouterReservations from "../../Dashboard/Reservations/ajoutreReservationst";
import ReservationsInfo from "../../Dashboard/Reservations/infoReservations";
import EditReservations from "../../Dashboard/Reservations/editReservations";
import ResumerReservations from '../../Dashboard/Reservations/resumerReservations';

//Client
import ClientPage from '../../Dashboard/Clients/clientPage';
import AjouterClient from "../../Dashboard/Clients/ajouterClient";
import ClientInfo from '../../Dashboard/Clients/clientInfo'
import ClientRegions from '../../Dashboard/Clients/clientFidelite';

//Finance
import FinancePage from '../../Dashboard/Finance/financePage';
import FinanceStat from "../../Dashboard/Finance/financeStat";


//Team
import TeamPage from '../../Dashboard/Team/teamPage';
import AjouterTeam from '../../Dashboard/Team/ajouterTeam';
import TeamPoste from '../../Dashboard/Team/teamPoste';
import TeamDemande from '../../Dashboard/Team/demandeTeam';
import TeamInfo from '../../Dashboard/Team/teamInfo'
import TeamAvance from '../../Dashboard/Team/teamAvance';


/* USED  */
import ProfilePage from '../../Dashboard/Used/Profile/profilePage'
import SettingPage from '../../Dashboard/Used/Setting/settingPage';
import ConfrimationPage from '../../Dashboard/Used/Setting/confirmation';
import UpdateSettingPage from '../../Dashboard/Used/Setting/updateSettingPage';
import PaymmentPage from '../../Dashboard/Used/Setting/paymment';
import ForumPage from '../../Dashboard/Used/Forum/notificationPage';
import DocumentationPage from '../../Dashboard/Used/Documentation/documentationPage';
import MessagesPages from '../../Dashboard/Used/Messages/messagesPage'
import SyncroniserPage from '../../Dashboard/Used/Upload/uploadPage';
import SauvgarderPage from '../../Dashboard/Used/Sauvgarder/dateBaseBU'


const SystemLanding = () => {
    const [shaowReciveNotif, setShowNotification] = useState(false)

	useEffect(() => {
	    //CheckAuthentification()
	    CheckLogIn()
	    CheckNotificationIsOk()
	},[]);

    const CheckAuthentification = () =>{
        const AuthenKey = localStorage.getItem(`${GConf.SystemTag}_AuthKeyISSet`);
        if (!AuthenKey) {
            window.location.href = "/Auth";
        }
    }

    const CheckNotificationIsOk = () =>{
            if (!localStorage.getItem('NotificationToken')) {
                axios.post(`${GConf.SharedApi}/parametre`, {
                    PID: GConf.PID,
                    SystemTag : GConf.systemTag
                })
                .then(function (response) { 
                    console.log('igyp')
                    if (response.data.tokenID && response.data.tokenID.Notif_Token == '' ) { 
                        setShowNotification(true)
                    } else {
                        localStorage.setItem('NotificationToken', response.data.tokenID.Notif_Token)
                    }
                    
                }) 
            } else {
                
            }
            
    }

    const RecevieNotificationCard = () => {
            const [loaderState, setLoaderState] = useState(false)
            const UpdateNotifToken = (genre,token) => {
                setLoaderState(true)
                if (genre == 'remove'  ) {
                    
                    axios.post(`${GConf.SharedApi}/parametre/update/notif-token`, {
                        PID : GConf.PID,
                        Token : '',
                    }).then(function (response) {
                        setShowNotification(!shaowReciveNotif); 
                        setLoaderState(false)
                    })
                }
                else {
                    
                    axios.post(`${GConf.SharedApi}/parametre/update/notif-token`, {
                        PID : GConf.PID,
                        Token : token,
                    }).then(function (response) {
                        setShowNotification(!shaowReciveNotif); 
                        setLoaderState(false)
                    }) 
                } 
            }
            async function requestPermission() {
                setLoaderState(true)
                //requesting permission using Notification API
                const permission = await Notification.requestPermission();
            
                if (permission === "granted") {
                const token = await getToken(messaging, {
                    vapidKey: 'BLi4rh1fVu7f9p_RBBscq7eQs3tY8yETbeW7p0tj2oH9oM0rnAxwSDs1F4Xy6Q0bITAo9F_fTxwLz3TA3-4Gw5U',
                });
            
                //We can send token to server
                console.log("Token generated : ", token);
                UpdateNotifToken('Add', token)
                localStorage.setItem('NotificationToken', token)
                setLoaderState(true)
                } else if (permission === "denied") {
                //notifications are blocked
                console.log("You denied for the notification");
                }
            }

            return(<>
            {
                shaowReciveNotif ? 
                    <div className='card-body border-div mb-1 mt-0' style={{backgroundColor: '#d1d1d1'}}> 
                        <div className='row'>
                            <div className='col-6 text-start align-self-center text-dark'> <span className='bi bi-bell'></span> Voulez vous recevoir les notifications ?</div>
                            <div className='col-6 text-end'>
                                <Button size='tiny' className='rounded bg-warning text-danger ' onClick={() => requestPermission()} > OUI <Loader inverted active={loaderState} inline size='tiny' className='ms-2 text-danger'/></Button>
                                <Button size='tiny' className='rounded ms-4' onClick={() => setShowNotification(false)} > NON  </Button> 
                            </div>
                        </div>
                    </div>
                :
                <></>
            }
                    
            </>)
    }

    const CheckLogIn = () =>{
        const pidIsSet = localStorage.getItem('PID');
        if (!pidIsSet) {window.location.href = "/login";}
    }

    return (<>
        <NavBar/>
        <br />
        <br />
        <br />
         
        <div className='row pt-4 m-1'>
                <div className='col-12 col-md-12 col-lg-2'><LeftSideCard /></div>
                <div className='col-12 col-md-12 col-lg-10'>
                        <RecevieNotificationCard />
                        <Outlet />
                </div>
        </div>
    </>);
}

const systemRouter = () => (
        <Route path="S" exact element={<SystemLanding />} >
            <Route path="" exact element={<MainPage />} />
            <Route path="ma" exact element={<MainPage />} />

            <Route path="rq" exact element={<Outlet />} >
                <Route path="" exact element={<RequestPage />} />
                <Route path="calendrier" exact element={<CalendarCommandes />} />
                <Route path="info/:CID" exact element={<RequestCommandeInfo />} />
            </Route>
             
            <Route path="vo" exact element={<Outlet />}>
                <Route path="" exact element={<VoiturePage />} />
                <Route path="ajouter" exact element={<AjouterVoiture />} />
                <Route path="modifier/:FID" exact element={<EditVoiture />} />
                <Route path="info/:FID" exact element={<VoitureInfo />} />
            </Route>

            <Route path="of" exact element={<Outlet />} >
                <Route path="" exact element={<OffrePage />} />
                <Route path="info/:OID" exact element={<OffreInfo />} />
            </Route>

            <Route path="rs" exact element={<Outlet />}>
                <Route path="" exact element={<ReservationsPage />} />
                <Route path="ajouter" exact element={<AjouterReservations />} />
                <Route path="resumer" exact element={<ResumerReservations />} />
                <Route path="modifier/:FID" exact element={<EditReservations />} />
                <Route path="info/:FID" exact element={<ReservationsInfo />} />
            </Route>
 
            <Route path="cl" exact element={<Outlet />} >
                <Route path="" exact element={<ClientPage />} />
                <Route path="ajouter" exact element={<AjouterClient />} />
                <Route path="info/:CLID" exact element={<ClientInfo />} />
                <Route path="classemment" exact element={<ClientRegions />} />
            </Route>
             
            <Route path="tm" exact element={<Outlet />} >
                <Route path="" exact element={<TeamPage />} />
                <Route path="info/:TID" exact element={<TeamInfo />} />
                <Route path="ajouter" exact element={<AjouterTeam />} />
                <Route path="postes" exact element={<TeamPoste />} />
                <Route path="avances" exact element={<TeamAvance />} />
                <Route path="presence" exact element={<TeamDemande />} />
            </Route>

            <Route path="fi" exact element={<Outlet />} >
                <Route path="" exact element={<FinancePage />} />
                <Route path="stat" exact element={<FinanceStat />} />
            </Route>

            <Route path="Profile" exact element={<ProfilePage />} />
            <Route path="Parametre" exact element={<SettingPage />} />
            <Route path="Parametre/paymment" exact element={<PaymmentPage />} />
            <Route path="Parametre/confirmation" exact element={<ConfrimationPage />} />
            <Route path="Parametre/p/:genre" exact element={<UpdateSettingPage />} />
            <Route path="forum" exact element={<ForumPage />} />
            <Route path="doc" exact element={<DocumentationPage />} />
            <Route path="messages" exact element={<MessagesPages />} />
            <Route path="syncroniser" exact element={<SyncroniserPage />} />
            <Route path="sauvgarder" exact element={<SauvgarderPage />} />
        </Route>
)

export default systemRouter 